module.exports = __webpack_public_path__ + "img/logo-light.1ad40174.png";